module.exports = __webpack_public_path__ + "static/media/hassan-ouajbir-515815-unsplash.4cbe9e3a.jpg";